document.querySelectorAll(".lux-scroll-horizontal").forEach((container) => {
    const scroll = container.querySelector(".lux-scroll");

    if (scroll && scroll.scrollWidth > scroll.clientWidth) {
        container.classList.add("is-scrollable");
    }
});
